import { useRef } from "react";
import { ConsultaPadrao } from "../../../../components/ConsultaPadrao";
import { model_lead } from "../../../../models";
import SubjectIcon from '@mui/icons-material/Subject';
import { LeadItem } from "../LeadItem";
import { formatData } from "../../../../commons/utils";

export const Lead = () => {
    const refDetalhes = useRef<any>();

    function functions(row: any) {
        return ([
            {
                label: 'Observações',
                click: () => { refDetalhes.current.openModal(row.empid, row.leadid) },
                icon: <SubjectIcon />, 
                color: '#0589a0'
            },

        ])
    }

    const columns = [
        { field: 'leadid', header: 'Código' },
        { field: 'leadnome', header: 'Nome' },
        { field: 'leadcontato', header: 'Contato' },
        { field: 'tipoProspeccao.tipprospecdescricao', header: 'Tipo Prospecção' },
        { field: 'prospect.prospnome', header: 'Aluno Indicador' },
        { field: 'leadindicacao', header: 'Terceiro Indicador' },
        { field: 'leadnascimento', header: 'Nascimento', body: (e: any) => formatData(e.leadnascimento) },
        { field: 'leadobs', header: 'Observação Cadastro', style: { width: window.innerWidth, whiteSpace: 'pre-wrap' } },
        { field: 'functions', style: { minWidth: '7rem', width: '7rem' } }
    ];

    return (
        <>
            <ConsultaPadrao model={model_lead} columns={columns} functions={functions} />
            <LeadItem ref={refDetalhes} />
        </>
    )
}